<template>
    <p class="settings-hide-msg">
        No settings for this app (at the funnel level)...
        You can check account wide settings...
    </p>           
</template>

<script>
export default {
    name: 'Empty'
}
</script>